<template>
    <form action="" class="" v-on:submit.prevent="createCategory">
        <FormErrors :errors="vuelidate.$errors" />
        <InputComponent type="text" placeholder="Nombre" :value="vuelidate.category.name.$model" v-model="vuelidate.category.name.$model" />
        <SubmitButtonComponent value="Guardar"/>
    </form>
</template>

<script>
import { ref } from '@vue/reactivity'
import InputComponent from './InputComponent.vue'
import SubmitButtonComponent from './SubmitButtonComponent.vue'
import FormErrors from './FormErrors.vue'
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import useApi from '../../Services/useApi'
import { Inertia } from '@inertiajs/inertia'
import useNotification from '../../Services/useNotification'

export default {
    components: {InputComponent,SubmitButtonComponent,FormErrors},
    props: ['category'],
    validations() {
        return {
            category: {
                name: {
                    required
                }
            },
        }
    },
    setup(props,{emit}){
        const vuelidate = useVuelidate();
        const api = useApi();
        const category= ref(props.category)
        const isEdit = category.value.name!=''
        const notificate = useNotification()

        const createCategory = async()=>{
            let validation = await vuelidate.value.$validate();

            if(validation){
                api.addCategory(category.value)
                .then(response=>{
                    console.log(response)
                    notificate.success('Categoria Creada con exito')
                    Inertia.reload()
                    emit('added')
                })
            }else{
                notificate.error('Revisa el formulario')
            }
        }

        return{
            category,
            createCategory,
            vuelidate
        }
    }
}
</script>

<style>

</style>